import { render } from "./VendorsForm.vue?vue&type=template&id=624d48fa&scoped=true"
import script from "./VendorsForm.vue?vue&type=script&lang=js"
export * from "./VendorsForm.vue?vue&type=script&lang=js"

import "./VendorsForm.vue?vue&type=style&index=0&id=624d48fa&scoped=true&lang=css"

import exportComponent from "../../../node_modules/@vue/cli-service/node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__scopeId',"data-v-624d48fa"]])

export default __exports__